import { render, staticRenderFns } from "./CardBlock.vue?vue&type=template&id=9f47859c&scoped=true&"
import script from "./CardBlock.vue?vue&type=script&lang=js&"
export * from "./CardBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f47859c",
  null
  
)

export default component.exports